/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Privacy_Meta_DescriptionInputs */

const ja_playdata_privacy_meta_description = /** @type {(inputs: Playdata_Privacy_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）のプライバシーポリシーのページです。`)
};

const en_playdata_privacy_meta_description = /** @type {(inputs: Playdata_Privacy_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy for the PLAYDATA service.`)
};

/**
* | output |
* | --- |
* | "Privacy policy for the PLAYDATA service." |
*
* @param {Playdata_Privacy_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_privacy_meta_description = /** @type {((inputs?: Playdata_Privacy_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Privacy_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_privacy_meta_description(inputs)
	return en_playdata_privacy_meta_description(inputs)
});